<script lang="ts">
  import { onMount } from "svelte";

  let container: HTMLDivElement;
  let centerX: number;
  let centerY: number;
  let containerWidth: number;
  let containerHeight: number;

  export let zoom: boolean;
  export let zoomClick: MouseEvent;
  export let scaleFactor: number = 2;
  export let offsetFactor: number = 0.1;

  const DEFAULT_SCALE = 1;

  $: zoom, zoomDidChange();

  onMount(() => {
    if (!container) return;

    containerWidth = container.clientWidth;
    containerHeight = container.clientHeight;
    centerX = containerWidth / 2;
    centerY = containerHeight / 2;
  });

  function zoomDidChange() {
    if (!container) return;
    if (zoom) {
      container.addEventListener("mousemove", handleMouseMove);
      zoomIn(zoomClick);
      zoomAroundPoint(zoomClick);
    } else {
      container.removeEventListener("mousemove", handleMouseMove);
      container.style.transform = `scale(${DEFAULT_SCALE})`;
    }
  }

  function handleMouseEnter(event: MouseEvent) {
    if (!zoom) return;
    zoomIn(event);
    container.addEventListener("mousemove", handleMouseMove);
  }

  function handleMouseLeave() {
    container.removeEventListener("mousemove", handleMouseMove);
    container.style.transform = `scale(${DEFAULT_SCALE})`;
  }

  function handleMouseMove(event: MouseEvent) {
    zoomAroundPoint(event);
  }

  function zoomIn(event: MouseEvent) {
    container.style.transformOrigin = `${event.offsetX}px ${event.offsetY}px`;
    container.style.transform = `scale(${DEFAULT_SCALE * scaleFactor})`;
  }

  function zoomAroundPoint(event: MouseEvent) {
    const containerWidth = container.clientWidth;
    const containerHeight = container.clientHeight;
    const centerX = containerWidth / 2;
    const centerY = containerHeight / 2;
    // Use offset factor so zoom can reach edges of the document
    const distanceX = Math.abs(centerX - event.offsetX);
    const distanceY = Math.abs(centerY - event.offsetY);

    let offsetX, offsetY;

    if (event.offsetX < centerX) {
      offsetX = Math.max(event.offsetX - distanceX * offsetFactor, 0);
    } else {
      offsetX = Math.min(event.offsetX + distanceX * offsetFactor, containerWidth);
    }

    if (event.offsetY < centerY) {
      offsetY = Math.max(event.offsetY - distanceY * offsetFactor, 0);
    } else {
      offsetY = Math.min(event.offsetY + distanceY * offsetFactor, containerHeight);
    }

    container.style.transformOrigin = `${offsetX}px ${offsetY}px`;
    container.style.transform = `scale(${DEFAULT_SCALE * scaleFactor})`;
  }
</script>

<div
  class="container"
  bind:this={container}
  on:mouseenter={handleMouseEnter}
  on:mouseleave={handleMouseLeave}
>
  <slot />
</div>

<style>
  .container {
    width: 100%;
    height: 100%;
    transition: transform 0.2s ease-in-out;
    overflow: scroll;
  }
</style>
